import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./Envelope.css";
import { useAudio } from "../../Context/AudioContext";

export default function Landing() {
  const [isOpen, setIsOpen] = useState(false);
  const [showEffects, setShowEffects] = useState(false); // Nuevo estado
  const navigate = useNavigate();
  const { play } = useAudio();

  // Detectar parámetro tipo en la URL
 const routerLocation = useLocation();
  const params = new URLSearchParams(routerLocation.search);
  const tipo = params.get("tipo"); // "c" o "s"

  const openEnvelope = () => {
    if (isOpen) return;
    setIsOpen(true);
     play(); // ▶️ Reproduce

    // Mostrar pétalos y destellos después de que se abra el sobre (1.8s)
    setTimeout(() => {
      setShowEffects(true);
    }, 500);

    // Navegar al home después de 4.5s
     setTimeout(() => {
      if (tipo === "c") {
        navigate("/home/c");
      } else {
        navigate("/home/s");
      }
    }, 4500);
  };

  return (
    <div className="landing-container">
      <div className="envelope-wrapper" aria-label="Sobre invitación">
        {/* Sobre */}
        <motion.div
          className="envelope"
          onClick={openEnvelope}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && openEnvelope()}
          initial={false}
        >
          {/* Cuerpo fijo del sobre con el texto */}
          <div className="envelope-body">
            {!isOpen && (
              <motion.p
                className="invitation-text"
                initial={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                Abrir invitación
              </motion.p>
            )}
          </div>

          {/* Tapa que se abre */}
          <motion.div
            className="envelope-flap"
            animate={{ rotateX: isOpen ? 180 : 0 }}
            transition={{ duration: 1.8, ease: "easeInOut" }}
          />
        </motion.div>

        {/* Efectos visuales: pétalos y destellos */}
        <AnimatePresence>
  {showEffects && (
    <>
      {/* Pétalos que emergen */}
      <motion.div
        className="emerging-petals"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {[...Array(50)].map((_, i) => {
          const randomRotate = Math.random() * 360;
          const randomY = -150 - Math.random() * 200;

          return (
            <motion.div
              key={i}
              className="petal"
              style={{ left: `${10 + Math.random() * 70}%` }}
              initial={{ y: 0, opacity: 0, scale: 0.6, rotate: 0 }}
              animate={{
                y: randomY,
                opacity: 1,
                scale: 1,
                rotate: randomRotate,
              }}
              transition={{
                duration: 3 + Math.random() * 1.5,
                ease: "easeOut",
                delay: i * 0.1 + 0.5,
              }}
            />
          );
        })}
      </motion.div>

      {/* Destellos que emergen y se mueven en diferentes direcciones */}
      <motion.div
  className="emerging-sparkles"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  exit={{ opacity: 0 }}
>
  {[...Array(100)].map((_, i) => {
    const randomX = Math.random() * 80 - 40;     // más controlado
    const randomY = -80 - Math.random() * 100;   // hacia arriba
    const left = 45 + Math.random() * 10;        // desde el centro
    const delay = i * 0.1 + 0.5;

    return (
      <motion.div
        key={i}
        className="sparkle"
        style={{
          top: `60%`,              // punto de origen
          left: `${left}%`,
        }}
        initial={{
          x: 0,
          y: 0,
          opacity: 0,
          scale: 0.5,
        }}
        animate={{
          x: randomX,
          y: randomY,
          opacity: 1,
          scale: 1,
        }}
        transition={{
          duration: 2,
          ease: "easeOut",
          delay,
        }}
      />
    );
  })}
</motion.div>


    </>
  )}
</AnimatePresence>

      </div>

      {/*<button
        className="open-button"
        onClick={openEnvelope}
        disabled={isOpen}
        aria-label="Abrir invitación"
      >
        {isOpen ? "Abriendo..." : "Abrir invitación"}
      </button>*/}
    </div>
  );
}
